import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosBlob } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API

export const compartilharPasta = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}PastaCompartilhada/compartilhar-pasta`, 'POST', data);
}

export const removerCompartilhamento = async (idUsuario, idPasta) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}PastaCompartilhada/remover-compartilhamento/${idUsuario}/${idPasta}`, 'DELETE');
}

export const sairDoCompartilhametno = async (idUsuario, idPasta) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}PastaCompartilhada/sair-compartilhamento/${idUsuario}/${idPasta}`, 'DELETE');
}

export const listarPastasCompartilhadasPorMim = async (idUsuario, tamanho, pagina, nomeDocumento,ordem) => {
  let buscarPorNome = nomeDocumento ? `&nomeDocumento=${nomeDocumento}` : ''

  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}PastaCompartilhada/pasta-compartilhadas-por-mim?idUsuario=${idUsuario}&pageSize=${tamanho}&pageNumber=${pagina}${buscarPorNome}&orderBy=${ordem?ordem : 'tipo asc, nomeOrdenacao asc'}`, 'GET');
}

export const listarPastasCompartilhadasComigo = async (idUsuario, tamanho, pagina, nomeDocumento, ordem) => {
  let buscarPorNome = nomeDocumento ? `&nomeDocumento=${nomeDocumento}` : ''

  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}PastaCompartilhada/pasta-compartilhadas-comigo?idUsuario=${idUsuario}&pageSize=${tamanho}&pageNumber=${pagina}${buscarPorNome}&orderBy=${ordem?ordem : 'tipo asc, nomeOrdenacao asc'}`, 'GET');
}

export const verificarPastaCompartilhada = async (idUsuario, idPasta) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}PastaCompartilhada/verificar-pasta-compartilhada/${idUsuario}/${idPasta}`, 'GET');
}
export const verificarDirecionamentoPastaArquivo = async (id) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}pasta/redirecionamento?${id}`, 'GET');
}